/* eslint-disable camelcase */
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import {
  Button, List, ListItem, ListItemButton, ListItemText, ListSubheader,
} from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import type { GuitarSettings } from '../../../../../context/TranscriptionDialogContext/TranscriptionDialogContext';
import { TranscriptionDialogContext } from '../../../../../context/TranscriptionDialogContext/TranscriptionDialogContext';

export interface GuitarStyleProps {
  setCurrentStep: (step: number) => void;
}

const CapoIcon = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_17_714)">
        <path
          d="M65.8396 0.0489502L66.0993 70.0205L63.3723 70.0307L63.1126 0.0590729L65.8396 0.0489502Z"
          fill="white"
        />
        <path
          d="M25.1355 -0.858337L25.4086 72.706L22.6816 72.7161L22.4085 -0.848215L25.1355 -0.858337Z"
          fill="white"
        />
        <path d="M56.3281 42.6562H63.9844V54.6875H56.3281V42.6562Z" fill="white" />
        <path d="M24.0625 58.5156H31.7188V70H24.0625V58.5156Z" fill="white" />
        <path d="M56.3388 58.5711H64.0365V70H56.3388V58.5711Z" fill="white" />
        <path d="M23.8844 43.006H31.5822V54.4806H23.8844V43.006Z" fill="white" />
        <path d="M23.8843 43.0059H31.5822V54.4806H23.8843V43.0059Z" fill="white" />
        <path d="M24.0625 15.3125H31.7188V27.3438H24.0625V15.3125Z" fill="white" />
        <path d="M56.3281 15.3125H63.9844V27.3438H56.3281V15.3125Z" fill="white" />
        <path d="M23.8844 0H31.5822V11.4289H23.8844V0Z" fill="white" />
        <path d="M35.5469 15.3125H42.6563V26.7969H35.5469V15.3125Z" fill="white" />
        <path d="M46.4844 15.3125H53.5938V26.7969H46.4844V15.3125Z" fill="white" />
        <path d="M45.9375 0H53.6353V11.4289H45.9375V0Z" fill="white" />
        <path d="M35 0H42.6978V11.4289H35V0Z" fill="white" />
        <path d="M56.3281 0H63.9844V10.9375H56.3281V0Z" fill="white" />
        <path d="M16.4512 32.7894H21.0949V37.776H16.4512V32.7894Z" fill="white" />
        <path
          d="M1.83517 35.2827C1.83517 38.1846 4.19603 40.5456 7.09803 40.5456H12.3607V30.02H7.09803C4.19603 30.0199 1.83517 32.3809 1.83517 35.2827Z"
          fill="white"
        />
        <path
          d="M21.3415 32.7317C21.3415 31.6271 22.2369 30.7317 23.3415 30.7317H68C69.1046 30.7317 70 31.6271 70 32.7317V37.2683C70 38.3728 69.1046 39.2683 68 39.2683H23.3415C22.2369 39.2683 21.3415 38.3728 21.3415 37.2683V32.7317Z"
          fill="#FCA50B"
        />
        <path d="M35.4531 58.5156H42.5625V70H35.4531V58.5156Z" fill="white" />
        <path d="M46.4844 58.5156H54.1406V70H46.4844V58.5156Z" fill="white" />
        <path d="M56.3281 58.5156H63.9844V70H56.3281V58.5156Z" fill="white" />
        <path d="M24.0625 42.6562H31.7187V54.6875H24.0625V42.6562Z" fill="white" />
        <path d="M24.0625 0H31.7187V10.9375H24.0625V0Z" fill="white" />
        <path d="M46.4844 0H53.5938V10.9375H46.4844V0Z" fill="white" />
        <path d="M35 0H42.6562V10.9375H35V0Z" fill="white" />
        <path d="M11.4844 32.8125H25.1562V37.7344H11.4844V32.8125Z" fill="#FCA50B" />
        <path
          d="M8.91961 30.7977C10.0242 30.7977 10.9196 29.9022 10.9196 28.7977V27.6097C10.9196 26.5052 10.0242 25.6097 8.91961 25.6097H8.82925C7.72468 25.6097 6.82925 26.5052 6.82925 27.6097V30.2196C6.82925 30.5442 7.10342 30.7977 7.42808 30.7977V30.7977H8.91961Z"
          fill="#FCA50B"
        />
        <path
          d="M7.42808 40.1431C7.10342 40.1431 6.82925 40.3966 6.82925 40.7213V43.3311C6.82925 44.4356 7.72468 45.3311 8.82925 45.3311H8.91961C10.0242 45.3311 10.9196 44.4356 10.9196 43.3311V42.1431C10.9196 41.0386 10.0242 40.1431 8.91961 40.1431H7.42808V40.1431Z"
          fill="#FCA50B"
        />
        <path
          d="M1.83516 35.2827C1.83516 38.1846 4.19602 40.5456 7.09801 40.5456H12.3607V30.02H7.09801C4.19602 30.0199 1.83516 32.3809 1.83516 35.2827Z"
          fill="#FCA50B"
        />
        <path d="M46.4844 42.6562H53.5938V54.6875H46.4844V42.6562Z" fill="white" />
        <path d="M35 42.6562H42.6562V54.6875H35V42.6562Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_17_714">
          <rect width="70" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const useStyles = makeStyles()((theme) => ({
  selection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    height: '7em',
    padding: 10,
    border: `1px solid #fff`,
    '&:hover': {
      boxShadow: `0px 0px 5px 0 ${theme.palette.primary.main}`,
      border: `1px solid ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
  },
  label: {
    display: 'flex',
    textTransform: 'none',
    justifyContent: 'center',
    width: '8em',
    color: '#d1cfcf',
    fontSize: '14px',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  noCapoIcon: {
    color: '#fff',
    fontSize: '40px',
    margin: '.3em 0',
  },
  list: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    overflowY: 'auto', // to make the list scrollable
  },
  listItem: {
    width: 'fit-content',
  },
}));

export interface CapoProps {
  setCurrentStep: () => void;
}

const Capo: React.FC<CapoProps> = ({ setCurrentStep }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const CAPOS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const { setSettings, settings } = React.useContext(TranscriptionDialogContext);
  const [showCapo, setShowCapo] = React.useState(false);

  const handleClick = (hasCapo: boolean) => {
    if (hasCapo === false) {
      setSettings({ capo: 0 }, settings.instruments[0]);
      setCurrentStep();
    } else {
      setShowCapo(true);
    }
  };

  const handleCapoChange = (capo: GuitarSettings['capo']) => {
    setSettings({ capo }, settings.instruments[0]);
    setCurrentStep();
  };

  return (
    <>
      <div className={classes.container}>
        <Button
          name="capo-used"
          id="btn_wizard_capo_yes"
          className={classes.selection}
          onClick={() => handleClick(true)}
        >
          <CapoIcon />
          <div className={classes.label}>{t('home.input.dialog.capo.yes')}</div>
        </Button>
        <Button
          name="capo-not-used"
          className={classes.selection}
          onClick={() => handleClick(false)}
          id="btn_wizard_capo_no"
        >
          <NotInterestedIcon className={classes.noCapoIcon} />
          <div className={classes.label}>{t('home.input.dialog.capo.no')}</div>
        </Button>
      </div>

      {showCapo && (
        <List
          className={classes.list}
          subheader={(
            <ListSubheader style={{ textWrap: 'nowrap' }} component="div" id="capo-selection">
              {t('home.input.dialog.capo.select')}
            </ListSubheader>
          )}
        >
          {CAPOS.map((capo) => (
            <ListItem key={capo} disablePadding>
              <ListItemButton
                id={`btn_wizard_capo_${capo}`}
                className={classes.listItem}
                onClick={() => handleCapoChange(capo as GuitarSettings['capo'])}
              >
                <ListItemText primary={capo} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      )}
    </>
  );
};

export default Capo;
